/**
 * Single admin portal date display format (US short).
 * Date: M/d/yy — Datetime: M/d/yy, h:mm a
 */

export type AdminDateMode = 'date' | 'datetime';

export function formatAdminDate(
  value: string | Date | null | undefined,
  mode: AdminDateMode = 'date',
  empty = '—'
): string {
  if (value == null || value === '') {
    return empty;
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) {
    return empty;
  }
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const year = String(d.getFullYear()).slice(-2);
  if (mode === 'datetime') {
    let hours = d.getHours();
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${month}/${day}/${year}, ${hours}:${minutes} ${ampm}`;
  }
  return `${month}/${day}/${year}`;
}
